import { NotificationContextProps } from '@celito.clients/shared';
import { createContext } from 'react';

export const NotificationContext = createContext<NotificationContextProps>({
  hasUnreadNotifications: false,
  setHasUnreadNotifications: (data: boolean) => {},
  refetchUnreadNotificationsStatus: () => {},
});
